
import { CACHE_CONFIG } from './cacheConfig';

/**
 * Generate cache key for a specific user
 */
export const getCacheKey = (userId: string, version: string = CACHE_CONFIG.VERSION): string => {
  return `${CACHE_CONFIG.PREFIX}_${userId}_${version}`;
};

/**
 * Get all cache keys for a user (across all versions)
 */
export const getUserCacheKeys = (userId: string): string[] => {
  const keys: string[] = [];
  
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(`${CACHE_CONFIG.PREFIX}_${userId}_`)) {
        keys.push(key);
      }
    }
  } catch (error) {
    console.error('Error reading localStorage keys:', error);
  }
  
  return keys;
};
